import axios from 'axios';

import { Utm } from '@/types/utm';

import { RequestService } from '../services/request.service';

type Payload = {
	name?: string;
	phone: string;
	company?: string;
	email?: string;
	source?: string; // Месейдж для отображение в crm ( пример: 'Запрос на демо с прода')
	utm_source?: string;
} & Utm;

type ErrorAnswer = {
	phone?: string[];
	email?: string[];
};

export const leads = async (body: Payload): Promise<ErrorAnswer | null> => {
	const request = RequestService.getInstance();

	try {
		await request.post<ErrorAnswer>('/api/v2/amo-crm/leads/', body);
		return null;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			const backendErrors = error.response?.data;

			if (backendErrors) {
				return backendErrors;
			}
		}

		throw new Error('Ошибка при отправке заявки на демо');
	}
};
